export default "__VITE_ASSET__BZch9gsG__"